import React from "react";
import { Modal } from "@mui/material";
import { formatProgramPrice } from "../utils/programPricing";
import { normalizeLabPricing } from "../utils/labPricing";
import "./OrderLabsDealModal.scss";

const OrderLabsDealModal = ({ open, onClose, onConfirm, pricing }) => {
  const { labRetailPrice, labMemberPrice, labDiscountPercent } =
    normalizeLabPricing(pricing);
  const percentLabel = Number.isInteger(labDiscountPercent)
    ? String(labDiscountPercent)
    : String(labDiscountPercent);

  return (
    <Modal open={open} onClose={onClose}>
      <div className="order-labs-deal" role="dialog" aria-modal="true">
        <div className="order-labs-deal__head">
          <button
            type="button"
            className="order-labs-deal__close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
          <p className="order-labs-deal__kicker">Order Labs</p>
          <h2>The Japa 97-Biomarker Lab Panel</h2>
          <p className="order-labs-deal__lede">
            One blood draw, read through biophysics, with a lesson for every
            marker.
          </p>
        </div>

        <div className="order-labs-deal__body">
          <div className="order-labs-deal__price-row">
            <p className="order-labs-deal__member-price">
              {formatProgramPrice(labMemberPrice)}
            </p>
            <p className="order-labs-deal__retail-price">
              {formatProgramPrice(labRetailPrice)}
            </p>
            <span className="order-labs-deal__tag">
              {percentLabel}% off for members
            </span>
          </div>

          <p className="order-labs-deal__note">
            Click Send my order link and we will email you a personal link to
            place your order. A $12 draw fee is paid at the lab.
          </p>

          <div className="order-labs-deal__actions">
            <button
              type="button"
              className="order-labs-deal__cta"
              onClick={onConfirm}
            >
              Send my order link
            </button>
            <button
              type="button"
              className="order-labs-deal__ghost"
              onClick={onClose}
            >
              Not now
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default OrderLabsDealModal;
